import React, { useRef, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { waveform } from "ldrs";
import { toast } from "react-toastify";
import { useDropdownStore } from "../AssetVehicle/store/useDropdownStore";
import { getWritePermission } from "../AssetVehicle/utils/helpers";
import FilePreview from "../AssetVehicle/FilePreview";
import { CorporationStore } from "./CorporationStore";

const CorporationForm = ({ handleClose }) => {
  waveform.register();
  const {
    filePreviews,
    handleFileChange,
    resetFileInputs,
    removeFilePreview,
    setFilePreviewFromUrl,
  } = useDropdownStore();
  const { EditData, saveCorporationDetails, isSaveCorporationLoading } =
    CorporationStore();

  useEffect(() => {
    if (EditData?.logo) {
      setFilePreviewFromUrl("Logo", EditData.logo);
    }
  }, [EditData]);

  const canWrite = getWritePermission(); // adjust if needed

  const initialVehicleDetails = {
    CorporationId: EditData?.corporationId || "",
    CorporationName: EditData?.corporationName || "",
    Logo: EditData?.logo || null,
    IsActive: EditData?.IsActive !== undefined ? EditData.IsActive : true,
  };

  const fileInputRef = useRef(null);

  const validationSchema = Yup.object().shape({
    CorporationName: Yup.string()
      .required("Corporation Name is required")
      .max(20, "Corporation Name must be at most 20 characters"),
    Logo: Yup.mixed(),
    IsActive: Yup.boolean(),
  });

  const handleRemoveLogo = (setFieldValue) => {
    setFieldValue("Logo", null);
    removeFilePreview("Logo");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Form values:", values);
    try {
      const response = await saveCorporationDetails(values, EditData);
      console.log("API response:", response);
      if (response.status === "success") {
        toast.success(
          EditData
            ? "Corporation updated successfully!"
            : "Corporation added successfully!",
        );
        resetForm();
        resetFileInputs();
        handleClose();
      } else {
        toast.error("Failed to save corporation details.");
      }
    } catch (error) {
      console.error("Error saving corporation details:", error);
      toast.error(error.message || "Failed to save corporation details.");
    }
  };

  return (
    <>
      <Formik
        initialValues={initialVehicleDetails}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <div className="row g-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Corporation Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    id="CorporationName"
                    maxLength="20"
                    name="CorporationName"
                    className="form-control"
                    placeholder="Enter Corporation Name"
                  />
                  <ErrorMessage
                    className="form-text text-danger"
                    name="CorporationName"
                    component="span"
                  />
                </div>
              </div>

              {/* File Uploads */}
              {/* ******************************** */}
              <div className="col-12">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="vehicleImageUrl" className="form-label">
                        Logo
                      </label>
                      <input
                        type="file"
                        id="Logo"
                        name="Logo"
                        accept=".png, .jpg, .jpeg"
                        ref={fileInputRef}
                        onChange={(e) => {
                          handleFileChange(e, "Logo");
                          setFieldValue("Logo", e.currentTarget.files[0]);
                        }}
                        className="form-control"
                      />
                      <ErrorMessage
                        className="form-text text-danger"
                        name="Logo"
                        component="span"
                      />
                      {filePreviews.Logo?.fileUrl && (
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <FilePreview
                            file={filePreviews.Logo.file}
                            fileType={filePreviews.Logo.fileType}
                            fileUrl={filePreviews.Logo.fileUrl}
                          />
                          <button
                            type="button"
                            onClick={() => handleRemoveLogo(setFieldValue)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              background: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              fontSize: "12px",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="IsActive"
                    value={true}
                    className="form-check-input"
                    checked={values.IsActive === true}
                    onChange={() => setFieldValue("IsActive", true)}
                  />
                  <label className="form-check-label">Active</label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <Field
                    type="radio"
                    name="IsActive"
                    value={false}
                    className="form-check-input"
                    checked={values.IsActive === false}
                    onChange={() => setFieldValue("IsActive", false)}
                  />
                  <label className="form-check-label">Inactive</label>
                </div>
              </div>
              {/* Submit Button */}
              <div className="modal-footer d-flex justify-content-center">
              
                  <button
                    type="submit"
                    className="deployment-button"
                    disabled={false}
                  >
                    {isSaveCorporationLoading ? (
                      <l-waveform
                        size="20"
                        stroke="3.5"
                        speed="1"
                        color="red"
                      ></l-waveform>
                    ) : (
                      <>
                        <i className="fa-solid fa-check done-container"></i>
                        {EditData ? "Update" : "Save"}
                      </>
                    )}
                  </button>
               
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};  

export default CorporationForm;
 